import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@spothero/ui/button';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import EnvironmentUtils from '@spothero/utils/environment';
import {getStore} from 'store/store';
import DateTimePickers from './DateTimePickers';

export default class ChangeDateTimeModal extends Component {
    static propTypes = {
        isMonthly: PropTypes.bool.isRequired,
        starts: PropTypes.string.isRequired,
        ends: PropTypes.string,
        title: PropTypes.string,
        introMessage: PropTypes.string.isRequired,
        showOtherOptions: PropTypes.bool,
        useCalendarWithShim: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onHidden: PropTypes.func.isRequired,
        onBackToSearchClick: PropTypes.func
    };

    constructor(props) {
        super(props);

        const {
            starts,
            ends
        } = props;

        this._isMobile = EnvironmentUtils.isMobileDevice();

        this.state = {
            start: moment(starts),
            end: (ends) ? moment(ends) : null,
            isTransientStartValid: true
        };
    }

    _onDateTimePickersChange = ({
        start,
        end,
        isValidStart
    }) => {
        this.setState({
            start,
            end,
            isTransientStartValid: isValidStart
        });
    }

    _onApplyClick = evt => {
        evt.preventDefault();

        this.props.onChange(this.state);
    }

    _onNearbyClick = evt => {
        evt.preventDefault();

        this._modal.hide(true);
    }

    render() {
        const {
            title,
            introMessage,
            isMonthly,
            starts,
            ends,
            showOtherOptions,
            useCalendarWithShim,
            onHidden,
            onBackToSearchClick
        } = this.props;
        const {
            isTransientStartValid
        } = this.state;
        const finalTitle = (title)
            ? title
            : (isMonthly) ? 'Change Date' : 'Change Time';

        return (
            <Modal
                ref={node => { this._modal = node; }}
                className="ChangeDateTimeModal"
                title={finalTitle}
                store={getStore()}
                onHidden={onHidden}
            >
                <ModalContent
                    className="datetime-range-picker-container"
                    noPadding={this._isMobile}
                >
                    <p>{introMessage}</p>
                    <DateTimePickers
                        isMonthly={isMonthly}
                        starts={starts}
                        ends={ends}
                        useCalendarWithShim={useCalendarWithShim}
                        onChange={this._onDateTimePickersChange}
                    />
                    <Button
                        className="Button-apply"
                        color="primary"
                        disabled={(isMonthly) ? false : !isTransientStartValid}
                        onClick={this._onApplyClick}
                    >
                        Apply
                    </Button>
                    {showOtherOptions &&
                        <div className="additional-options">
                            <HorizontalRule lineStyle="dotted">or</HorizontalRule>
                            <Button
                                color="secondary"
                                onClick={this._onNearbyClick}
                            >
                                View Nearby Spots
                            </Button>
                            {onBackToSearchClick &&
                                <Button
                                    color="secondary"
                                    onClick={onBackToSearchClick}
                                >
                                    Return to Search
                                </Button>
                            }
                        </div>
                    }
                </ModalContent>
            </Modal>
        );
    }
}
